import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FieldTypeListExtendedComponent } from '../../../shared/components/field-type-list-extended/field-type-list-extended.component';
import { FieldTypeDateComponent } from '../../../shared/components/field-type-date/field-type-date.component';
import { FormsModule } from '@angular/forms';
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'customize-field-date',
    templateUrl: './customize-field-date.component.html',
    standalone: true,
    imports: [
      FormsModule,
      FieldTypeDateComponent,
      FieldTypeListExtendedComponent,
      CustomizeFieldsSwitchFormComponent,
      FieldTypeSwitchComponent,
      AfTranslatePipe
    ]
})
export class CustomizeFieldDateComponent implements OnChanges {
  customizeFieldDate:any = {
    defaultValueInfo:{
      label: this.translate.instant('customize.default-value'),
    },
    dateLimitsConfig: {
      multiple: false,
      label: this.translate.instant('customize.date-limits-title'),
      values: [
          {
              text: this.translate.instant('customize.date-limits-options.option-0'),
              listValueId: 0
          },
          {
              text: this.translate.instant('customize.date-limits-options.option-1'),
              listValueId: 1
          },
          {
              text: this.translate.instant('customize.date-limits-options.option-2'),
              listValueId: 2
          },
          {
              text: this.translate.instant('customize.date-limits-options.option-3'),
              listValueId: 3
          },
          {
              text: this.translate.instant('customize.date-limits-options.option-4'),
              listValueId: 4
          }
      ]
    }
  }

  constructor(
    private translate: AfTranslateFactory) { }
  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = null;
  @Input() typeView: string = 'normal';
  @Input() previewMode: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    let that: any = this.customizeFieldDate;
    that.disabledFormConfiguration = this.previewMode || this.concept?.disabled;
    if(changes['field'] && changes['field'].currentValue){
      that.field = changes['field'].currentValue;
      that.defaultValueInfo.noEditable = that.field.noEditable;
      that.dateLimitsConfig.selectedLimitType = that.field.dateLockType ? that.field.dateLockType : 0;
    }
    if(this.concept?.poll && this.concept?.disabled){
      that.defaultValueInfo.noEditable = true;
    }
    if(this.previewMode){
      that.dateLimitsConfig.noEditable = true;
      that.defaultValueInfo.noEditable = true;
    }
  }

  itemSelected(e:any, type: any){
    this.customizeFieldDate.field[type] = e.newValue;
    if( type === 'dateLockType'){
      if(e.newValue !== 0){
        this.customizeFieldDate.field.defaultValue = null;
        this.customizeFieldDate.defaultValueInfo.noEditable = true;
      }else{
        this.customizeFieldDate.defaultValueInfo.noEditable = false;
      }
    }else if(type === 'showTime'){
      this.customizeFieldDate.defaultValueInfo.showTime = e.newValue;
    }
  }
}
